interface Props {
  [key: string]: any
}

export default function HomChecklistIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 49 49" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 38.5V13.5H44.5V38.5C44.5 39.6 43.6 40.5 42.5 40.5H6.5C5.4 40.5 4.5 39.6 4.5 38.5Z" fill="#7D38D6" />
      <path d="M44.5 10.5V13.5H4.5V10.5C4.5 9.4 5.4 8.5 6.5 8.5H42.5C43.6 8.5 44.5 9.4 44.5 10.5Z" fill="#A37DD5" />
      <path
        d="M29 23.5H10C9.7 23.5 9.5 23.3 9.5 23V21C9.5 20.7 9.7 20.5 10 20.5H29C29.3 20.5 29.5 20.7 29.5 21V23C29.5 23.3 29.3 23.5 29 23.5Z"
        fill="white"
      />
      <path
        d="M35.0998 24.3L32.6998 21.9C32.4998 21.7 32.4998 21.3 32.6998 21.1L33.4998 20.3C33.6998 20.1 34.0998 20.1 34.2998 20.3L35.3998 21.4L38.8998 17.9C39.0998 17.7 39.4998 17.7 39.6998 17.9L40.4998 18.7C40.6998 18.9 40.6998 19.3 40.4998 19.5L35.6998 24.3C35.7998 24.5 35.3998 24.5 35.0998 24.3Z"
        fill="white"
      />
      <path
        d="M29 33.5H10C9.7 33.5 9.5 33.3 9.5 33V31C9.5 30.7 9.7 30.5 10 30.5H29C29.3 30.5 29.5 30.7 29.5 31V33C29.5 33.3 29.3 33.5 29 33.5Z"
        fill="white"
      />
      <path
        d="M35.0998 34.1999L32.6998 31.7999C32.4998 31.5999 32.4998 31.1999 32.6998 30.9999L33.4998 30.1999C33.6998 29.9999 34.0998 29.9999 34.2998 30.1999L35.3998 31.2999L38.8998 27.7999C39.0998 27.5999 39.4998 27.5999 39.6998 27.7999L40.4998 28.5999C40.6998 28.7999 40.6998 29.1999 40.4998 29.3999L35.6998 34.1999C35.7998 34.4999 35.3998 34.4999 35.0998 34.1999Z"
        fill="white"
      />
    </svg>
  )
}
